import { Component } from '@angular/core';

import { BaseIconComponent } from './base-icon.component';

/** The design system's `file-06`: a sheet with its text lines, for a filed document. */
@Component({
  selector: 'app-file-lines-icon',
  template: `<svg
    [attr.width]="width"
    [attr.height]="height"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M9.33333 1.51302V4.26671C9.33333 4.64008 9.33333 4.82677 9.406 4.96937C9.46991 5.09482 9.5719 5.1968 9.69734 5.26072C9.83995 5.33338 10.0266 5.33338 10.4 5.33338H13.1537M10.6667 8.66667H5.33333M10.6667 11.3333H5.33333M6.66667 6H5.33333M9.33333 1.33333H5.86667C4.74656 1.33333 4.18651 1.33333 3.75869 1.55132C3.38236 1.74307 3.0764 2.04903 2.88465 2.42535C2.66667 2.85318 2.66667 3.41323 2.66667 4.53333V11.4667C2.66667 12.5868 2.66667 13.1468 2.88465 13.5746C3.0764 13.951 3.38236 14.2569 3.75869 14.4487C4.18651 14.6667 4.74656 14.6667 5.86667 14.6667H10.1333C11.2534 14.6667 11.8135 14.6667 12.2413 14.4487C12.6176 14.2569 12.9236 13.951 13.1153 13.5746C13.3333 13.1468 13.3333 12.5868 13.3333 11.4667V5.33333L9.33333 1.33333Z"
      [attr.stroke]="color"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg> `,
})
export class FileLinesIcon extends BaseIconComponent {}
